import { formatISO, isValid, parseISO } from "date-fns";
import { buildQuickFiltersData, QUICK_FILTERS, type QuickFilter } from "@/hooks/use-chart-filters";

export type StatisticsSearch = {
	q?: QuickFilter;
	from?: string;
	to?: string;
};

export function validateStatisticsSearch(search: Record<string, unknown>): StatisticsSearch {
	const q = typeof search.q === "string" && QUICK_FILTERS.includes(search.q) ? search.q : "7d";
	const quickFilters = buildQuickFiltersData();
	const quickFilter = !["all", "custom"].includes(q)
		? quickFilters.find((f) => f.key === q)
		: undefined;

	return {
		q,
		from:
			typeof search.from === "string" && isValid(parseISO(search.from))
				? search.from
				: quickFilter?.value?.from
					? formatISO(quickFilter.value.from, { representation: "date" })
					: undefined,
		to:
			typeof search.to === "string" && isValid(parseISO(search.to))
				? search.to
				: quickFilter?.value?.to
					? formatISO(quickFilter.value.to, { representation: "date" })
					: undefined,
	};
}
